export type FeatureFlagKey =
  | 'webMarketingExperience'
  | 'webGuestMaintenanceMode'
  | 'webDesktopCompanionPanels'
  | 'webDesktopNavigationRail'
  | 'webAiAssistant'
  | 'webProposalsFeed';

type FeatureFlagMap = Record<FeatureFlagKey, boolean>;

const readEnvFlag = (envName: string, fallback: boolean): boolean => {
  const raw = process.env[envName];
  if (raw === undefined) {
    return fallback;
  }

  const value = raw.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(value)) {
    return true;
  }
  if (['0', 'false', 'no', 'off'].includes(value)) {
    return false;
  }
  return fallback;
};

const defaults: FeatureFlagMap = {
  webMarketingExperience: true,
  webGuestMaintenanceMode: true,
  webDesktopCompanionPanels: true,
  webDesktopNavigationRail: true,
  webAiAssistant: false,
  webProposalsFeed: false,
};

const envOverrides: FeatureFlagMap = {
  webMarketingExperience: readEnvFlag('REACT_APP_FLAG_WEB_MARKETING_EXPERIENCE', defaults.webMarketingExperience),
  webGuestMaintenanceMode: readEnvFlag('REACT_APP_FLAG_WEB_GUEST_MAINTENANCE_MODE', defaults.webGuestMaintenanceMode),
  webDesktopCompanionPanels: readEnvFlag('REACT_APP_FLAG_WEB_DESKTOP_COMPANION_PANELS', defaults.webDesktopCompanionPanels),
  webDesktopNavigationRail: readEnvFlag('REACT_APP_FLAG_WEB_DESKTOP_NAV_RAIL', defaults.webDesktopNavigationRail),
  webAiAssistant: readEnvFlag('REACT_APP_FLAG_WEB_AI_ASSISTANT', defaults.webAiAssistant),
  webProposalsFeed: readEnvFlag('REACT_APP_FLAG_WEB_PROPOSALS_FEED', defaults.webProposalsFeed),
};

export const featureFlags: FeatureFlagMap = {
  ...defaults,
  ...envOverrides,
};

export const isFeatureEnabled = (key: FeatureFlagKey): boolean => featureFlags[key];
